import {feLogger, transPageInfo as transData} from './index';

enum RepType {
    Click = 'click',
    Show = 'show',
}

export enum EventNameMap {
    historyRevert = 'historyrevert',
    wsFail = 'wsFail',
    wsBackupMaxFail = 'wsBackupMaxFail',
    wsBackupFirstSuccess = 'wsBackupFirstSuccess',
}

const eventIdMap: {
    [key: string]: string;
} = {
    [EventNameMap.historyRevert]: '80001.15.1',
    [EventNameMap.wsFail]: '80001.2.141',
    [EventNameMap.wsBackupMaxFail]: '80001.8.109',
    [EventNameMap.wsBackupFirstSuccess]: '80001.8.114',
};

// eslint-disable-next-line max-len
export const reportRteEvent = (key: EventNameMap, data: any = {}, type: 'click'|'show' = RepType.Click, keepCamel?: boolean) => {
    return feLogger({
        rep_id: eventIdMap[key],
        rep_type: type,
        rep_params: keepCamel ? {...data} : {
            ...transData(data),
        },
    });
};
